import { createTheme } from '@mui/material/styles'
import palette from './palette'

const theme = createTheme({
  typography: {
    fontFamily: 'Roobert, sans-serif',
    h1: { fontFamily: 'PPRightGrotesk, sans-serif' },
    h2: { fontFamily: 'PPRightGrotesk, sans-serif' },
    h3: { fontFamily: 'PPRightGrotesk, sans-serif' },
    // h4, h5, h6, and body will inherit Roobert
  },
  components: {
    MuiSvgIcon: {
      variants: [
        {
          props: { color: 'forestPlaceholder' },
          style: { color: palette.forestPlaceholder },
        },
        {
          props: { color: 'apple' },
          style: { color: palette.apple },
        },
      ],
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          color: palette.forest,
        },
      },
      variants: [
        {
          props: { color: 'forestPlaceholder' },
          style: { color: palette.forestPlaceholder },
        },
        {
          props: { color: 'apple' },
          style: { color: palette.apple },
        },
      ],
    },
    MuiRadio: {
      styleOverrides: {
        root: {
          color: palette.forest,
          padding: '3px',
          '&.Mui-checked': {
            color: palette.forest,
          },
          '&:hover': {
            backgroundColor: palette.forestSemitransparent,
          },
        },
      },
    },
    // https://www.figma.com/design/36nWYJacVJU7Qx02p5drkv/Fruitful-Office?node-id=238-73&t=TkLxHPykWi4fSD9J-0
    MuiFormControlLabel: {
      styleOverrides: {
        root: {
          marginLeft: '0',
          padding: '2px 12px',
          borderRadius: '10px',
          backgroundColor: '#F5F5F5',
          marginBottom: '8px',
          width: '100%',
          '& .MuiTypography-root': {
            fontFamily: 'Roobert, sans-serif',
            color: palette.forest,
            fontWeight: 500,
            marginLeft: '4px',
          },
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        select: {
          color: palette.forest,
          fontSize: '12px',
          fontWeight: 600,
          paddingBottom: '6px',
          '&.Mui-disabled': {
            color: palette.forestPlaceholder,
            WebkitTextFillColor: palette.forestPlaceholder,
          },
        },
        icon: {
          color: palette.forest,
          '&.Mui-disabled': {
            color: palette.forestPlaceholder,
          },
        },
        root: {
          height: '34.25px',
          paddingBottom: '4px', // Roughly centres the text
          borderWidth: 1,
          borderRadius: 10,
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: `${palette.forest} !important`,
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderWidth: 1,
            borderColor: `${palette.apple} !important`,
          },
        },
      },
    },
    MuiAutocomplete: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            height: '34.25px',
            paddingBottom: '4px',
            borderWidth: 1,
            borderRadius: 10,
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: `${palette.forest} !important`,
            },
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
              borderWidth: 1,
              borderColor: `${palette.apple} !important`,
            },
          },
        },
        input: {
          color: palette.forest,
          fontSize: '12px',
          fontWeight: 600,
          padding: '0 !important',
          '&.Mui-disabled': {
            color: palette.forestPlaceholder,
            WebkitTextFillColor: palette.forestPlaceholder,
          },
        },
        endAdornment: {
          color: palette.forest,
          '& .MuiSvgIcon-root': {
            color: palette.forest,
          },
        },
        paper: {
          boxShadow: 'none',
          border: `1px solid ${palette.forestSemitransparent}`,
          padding: '4px 12px',
          borderRadius: '10px',
        },
        option: {
          color: palette.forest,
          fontSize: '0.75rem',
          borderRadius: '6px',
          padding: '6px 12px',
          '&:hover': {
            backgroundColor: palette.cream,
          },
          '&.Mui-selected': {
            backgroundColor: palette.ginger,
            '&:hover': {
              backgroundColor: palette.ginger,
            },
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          '&.MuiMenu-paper': {
            boxShadow: 'none',
            border: `1px solid ${palette.forestSemitransparent}`,
            padding: '4px 12px',
            borderRadius: '10px',
          },
          '&.MuiAutocomplete-paper': {
            boxShadow: 'none',
            border: `1px solid ${palette.forestSemitransparent}`,
            padding: '4px 12px',
            borderRadius: '10px',
          },
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          color: palette.forest,
          fontSize: '0.75rem',
          borderRadius: '6px',
          padding: '6px 12px',
          '&:hover': {
            backgroundColor: palette.cream,
          },
          '&.Mui-selected': {
            backgroundColor: palette.ginger,
            '&:hover': {
              backgroundColor: palette.ginger,
            },
          },
        },
      },
    },
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          color: palette.forest,
          marginBottom: '0.5rem',
          display: 'flex',
          alignItems: 'center',
          gap: '6px',
        },
      },
    },
    // https://www.figma.com/design/36nWYJacVJU7Qx02p5drkv/Fruitful-Office?node-id=470-4877&m=dev
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderWidth: 1,
          borderRadius: 10,
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: palette.forest,
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderWidth: 1,
            borderColor: palette.apple,
          },
        },
        input: {
          color: palette.forest,
        },
      },
    },
  },
})

export default theme
